import { Injectable } from '@angular/core';
import { vPasswordEnum } from 'src/app/common/enum/vPassword.enum';

@Injectable({
    providedIn: 'root'
  })

export class passwordPolicy {
    constructor(){}
    private readonly errorMessage: vPasswords[] = [
        new vPasswords(vPasswordEnum.Length,'12','La contraseña debe tener al menos 12 caracteres. Por favor, ingrese una contraseña más larga.'),
        new vPasswords(vPasswordEnum.Upper, "[A-Z]", "La contraseña debe contener al menos una letra mayúscula. Por favor, ingrese una contraseña que cumpla con estos requisitos."),
        new vPasswords(vPasswordEnum.Lower, "[a-z]", "La contraseña debe contener al menos una letra minúscula. Por favor, ingrese una contraseña que cumpla con estos requisitos."),
        new vPasswords(vPasswordEnum.Number, "[0-9]", "La contraseña debe contener al menos un número. Por favor, ingrese una contraseña que cumpla con estos requisitos."),
        new vPasswords(vPasswordEnum.SpecialChar, "[^A-Za-z0-9]", "La contraseña debe contener al menos un carácter especial. Por favor, ingrese una contraseña que cumpla con estos requisitos."),
        new vPasswords(vPasswordEnum.ConfirmPassword, '', "Confirmar contraseña."),
        new vPasswords(vPasswordEnum.ComparePassword, '', "Las contraseñas no coinciden. Por favor, verifica que ambas contraseñas sean idénticas.")
    ];

    vPassword(password:string, confirmPassword:string):{isValid:boolean, message:string}{
        let isValid = true;
        let message = '';

        for(let i = 0; i < this.errorMessage.length; i++){
            const item = this.errorMessage[i];
            switch(item.type){
                case vPasswordEnum.Length:
                    message = password.length < Number(item.value) ? item.message : '';
                    break;
                case vPasswordEnum.ConfirmPassword:
                        message = confirmPassword == '' ? item.message : '';
                        break;
                case vPasswordEnum.ComparePassword:
                    message = password != confirmPassword ? item.message : '';
                    break;
                default:
                    message = !new RegExp(item.value).test(password)?item.message : '';
                    break;
            }
            if(message){
                isValid = false;
                break;
            }
        }
        return { isValid, message };
    }
}

export class vPasswords{
    constructor(
        public type: vPasswordEnum,
        public value: string,
        public message: string
    ) {}
}

